import styled from 'styled-components'
import { formatDate } from '@/utils/date.utils'

import Link from 'next/link'
import Image from 'next/image'

import { IPost } from '@/types/post.types'
import placeholderImage from '../../../public/assets/card/card-placeholder-light.svg'

export interface IProps {
  latestPosts: IPost[]
  patreonPosts: IPost[]
}

const Sidebar = ({ latestPosts, patreonPosts }: IProps) => {
  return (
    <SidebarContainer>
      <TitleContainer>
        <h3>Autor</h3>
      </TitleContainer>
      <Avatar>
        <Image
          src="/assets/ivetars_avatar-v2.jpeg"
          alt="Ivetars author photo"
          width={200}
          height={200}
        />
      </Avatar>
      <Name>iF.</Name>
      {/* <Quote>&ldquo;Ale preboha živého, prosYnta..&ldquo;</Quote> */}
      <TitleContainer>
        <h3>Najnovšie články</h3>
      </TitleContainer>
      <List>
        {latestPosts?.map((post) => (
          <li key={post.id}>
            <figure>
              <Image
                {...placeholderImage}
                src={post.meta?.image ?? placeholderImage}
                alt={post.meta?.image ?? post.title}
                width={40}
                height={40}
                placeholder="blur"
                blurDataURL={placeholderImage.src}
              />
            </figure>
            <div>
              <p>{formatDate(post.createdAt)}</p>
              <Link
                href={post.isPublic ? `/blog/${post.slug}` : post.url ?? ''}
              >
                {post.title}
              </Link>
            </div>
          </li>
        ))}
      </List>
      <TitleContainer>
        <h3>PATRÓNI ČÍTAJÚ</h3>
      </TitleContainer>
      <List>
        {patreonPosts?.map((post) => (
          <li key={post.id}>
            <figure>
              <Image
                {...placeholderImage}
                src={post.meta?.image ?? placeholderImage}
                alt={post.meta?.image ?? post.title}
                width={40}
                height={40}
                placeholder="blur"
                blurDataURL={placeholderImage.src}
              />
            </figure>
            <div>
              <p>{formatDate(post.createdAt)}</p>

              <Link
                href={post.isPublic ? `/blog/${post.slug}` : post.url ?? ''}
              >
                {post.title}
              </Link>
            </div>
          </li>
        ))}
      </List>
    </SidebarContainer>
  )
}

export default Sidebar

const SidebarContainer = styled.div`
  grid-area: sidebar;
  padding: 10rem 2rem;
  /* background-color: ${({ theme }) => theme.colors.primary}; */
`

const TitleContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
  padding: 0.5rem 1rem;
  border-radius: 0.1rem;
  margin-bottom: 1rem;

  h3 {
    color: ${({ theme }) => theme.fonts.primary};
    font-size: 1.4rem;
    font-weight: 500;
    margin: 0;
    text-transform: uppercase;
  }
`

const Avatar = styled.figure`
  border-radius: 50%;
  overflow: hidden;
  width: 20rem;
  height: 20rem;
  margin: 0 auto 1rem;
  border: 4px solid ${({ theme }) => theme.colors.secondary};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Name = styled.h4`
  text-align: center;
  font-weight: 400;
  font-size: 2.5rem;
  margin-bottom: 4rem;
`

const Quote = styled.p`
  margin-bottom: 4rem;
  text-align: center;
  font-size: 1.4rem;
  opacity: 0.8;
`

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 4rem 1.5rem;
  li {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
    font-size: 1.4rem;
    a {
      color: ${({ theme }) => theme.fonts.secondary};
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`
